var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserAddPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14286 3.42857C9.14286 5.32212 7.60783 6.85714 5.71429 6.85714C3.82074 6.85714 2.28571 5.32212 2.28571 3.42857C2.28571 1.53502 3.82074 0 5.71429 0C7.60783 0 9.14286 1.53502 9.14286 3.42857ZM12.2857 8.57143C12.7591 8.57143 13.1429 8.95518 13.1429 9.42857V11.4286H15.1429C15.6162 11.4286 16 11.8123 16 12.2857C16 12.7591 15.6162 13.1429 15.1429 13.1429H13.1429V15.1429C13.1429 15.6162 12.7591 16 12.2857 16C11.8123 16 11.4286 15.6162 11.4286 15.1429V13.1429H9.42857C8.95518 13.1429 8.57143 12.7591 8.57143 12.2857C8.57143 11.8123 8.95518 11.4286 9.42857 11.4286H11.4286V9.42857C11.4286 8.95518 11.8123 8.57143 12.2857 8.57143ZM5.71429 8C7.42099 8 8.95294 8.74822 10 9.93454V10H9.42857C8.16621 10 7.14286 11.0233 7.14286 12.2857C7.14286 13.1463 7.61845 13.8958 8.32114 14.2857H0.571429C0.255837 14.2857 0 14.0299 0 13.7143C0 10.5584 2.55837 8 5.71429 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAddPlus);
export default __webpack_public_path__ + "static/media/user-add-plus.c4fbb4f3ab475fb755fb64bcf16ff229.svg";
export { ForwardRef as ReactComponent };